import Chip from "@material-ui/core/Chip";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import React, { FC, useContext } from "react";
import TranslatedMessage from "../translations/TranslatedMessage";
import { SchedulerContextValue } from "./context/SchedulerContext";

const SchedulerLanguagesRow: FC = () => {
  const { selectedExamDayId, rooms, examDays } = useContext(SchedulerContextValue);

  const getLanguagesForDayAndRoom = (roomId: string) => {
    const examDay = examDays.find((examDay) => examDay.id === selectedExamDayId);
    const roomAssignment = examDay?.roomAssignments.find((r) => r.roomId === roomId);
    if (roomAssignment !== undefined) {
      var roomLanguages = roomAssignment.languages;
      if (roomLanguages.length > 0) {
        return roomLanguages.map((l) => <Chip key={l} label={l} />);
      }
    }

    return <TranslatedMessage id="common.noLanguagesAssigned" />;
  };

  const translationId = "common.languages";
  return (
    <TableRow>
      <TableCell key={translationId}>
        <TranslatedMessage id={translationId} />
      </TableCell>
      {rooms.map((room) => (
        <TableCell key={room.id}>{getLanguagesForDayAndRoom(room.id)}</TableCell>
      ))}
    </TableRow>
  );
};

export default SchedulerLanguagesRow;
